import React, { useContext, useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import SidebarLayout from "../components/shared/SidebarLayout";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import obj from "../Utils/helpers";
import AuthContext from "../context/AuthContext";
import { isEmpty } from "lodash";
import { IoIosArrowForward } from "react-icons/io";
const SpinReport = () => {
  const { userCoins, user } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [listing, setListing] = useState([]);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handel = () => {
    setFilter({
      ...filter,
      page: filter?.page + 1,
    });
    getData(
      {
        ...filter,
        page: filter?.page + 1,
      },
      "add"
    );
  };
  const getData = async (obj = filter, type) => {
    const { status, data } = await apiGet(apiPath.spinReport, obj);
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
        if (type == "add") {
          setListing([...listing, ...(data?.results?.data || [])]);
        } else {
          setListing(data?.results?.data || []);
        }
      }
    }
  };
  useEffect(() => {
    if (!isEmpty(user)) {
      getData();
    }
  }, [user]);

  return (
    <SidebarLayout heading={"Spin Report"}>
      <div className="p-3 pt-4 inner-sidebar-content d-flex flex-column ">

        {listing?.length > 0
          ? listing?.map((res, index) => {
              return (
                <div key={res?._id || index} className="balance-deposit-sec mt-3">
                  <Table
                    style={{ borderRadius: ".5rem" }}
                    bordered
                    className=" overflow-hidden bg-white"
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            fontWeight: "400",
                            fontSize: ".8571428571428571rem",
                            padding: ".3rem .5rem",
                          }}
                          colSpan="4"
                        >
                          {obj.dateFormat(res?.createdAt, user?.timeZone)}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            padding: "3px 5px",
                            fontSize: ".7142857142857143rem",
                          }}
                          width="50%"
                        >
                          Spin Count
                          <strong
                            style={{ fontSize: "14px" }}
                            className="d-block"
                          >
                            {res?.spin}
                          </strong>
                        </td>
                        <td
                          style={{
                            padding: "3px 5px",
                            fontSize: ".7142857142857143rem",
                          }}
                          width="50%"
                        >
                          Profit / Loss
                          <strong
                            style={{ fontSize: "14px" }}
                            className={`d-block ${
                              Number(res?.result) < 0
                                ? "text-danger"
                                : "text-success"
                            }`}
                          >
                            {res?.result}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              );
            })
          : "No Record Found"}
        {data?.hasNextPage && (
          <div className="w-100 d-flex justify-content-center align-items-center">
            <Button
              onClick={handel}
              style={{ background: "black", border: "none" }}
            >
              Show More <IoIosArrowForward />
            </Button>
          </div>
        )}
      </div>
    </SidebarLayout>
  );
};

export default SpinReport;
